// extracted by mini-css-extract-plugin
export default {"controlSettingWrapper":"ControlSettingWrapper_controlSettingWrapper__hyYgZ"};